import { useQuery } from '@tanstack/react-query';

import { awaitJSON, DagLambdaFetch } from '@src/utils/fetch-utils';

import { DagGraphRow } from './dag-graphs-constants';

export const useDagGraphs = (): ReturnType<typeof useQuery<DagGraphRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['dagGraphs'],
    queryFn: async (): Promise<DagGraphRow[]> =>
      awaitJSON<DagGraphRow[]>(await DagLambdaFetch('/dag_graphs'))
  });
